/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../../_helpers';
import axios, { baseUrl } from '../../../../redux/my-axios';
const URL = '/dashboard';
export function TilesWidget11({
  className,
  baseColor = 'primary',
  widgetHeight = '150px',
  title,
  target = 'MERCHANT',
  freq,
  type,
  freqFrom,
  icon = '/media/svg/icons/Layout/Layout-4-blocks.svg',
}) {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState();
  useEffect(() => {
    setLoading(true);
    axios
      .post(
        URL,
        { target, type, freq, freqFrom },
        { headers: { action: 'getstate' } }
      )
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            //console.log('Dashboard: ', response.data.data);
            setValue(Number(response.data.data.statisticData));
            setLoading(false);
            break;
          default:
            console.log('Dashboard Error: ', response.data);
            setLoading(false);
            break;
        }
      })
      .catch((error) => {
        console.log(error);

        setLoading(false);
      });
    return function cleanup() {};
  }, []);
  return (
    <>
      <div
        className={`card card-custom bg-${baseColor} ${className}`}
        style={{ height: widgetHeight }}
      >
        <div className='card-body'>
          <span className='svg-icon svg-icon-3x svg-icon-white ml-n2'>
            <SVG src={toAbsoluteUrl(icon)} />
          </span>
          <div
            className={`text-inverse-${baseColor} font-weight-bolder font-size-h2 mt-3`}
          >
            {value}
          </div>

          <a
            href='#'
            className={`text-inverse-${baseColor} font-weight-bold font-size-lg mt-1`}
          >
            {title}
          </a>
        </div>
      </div>
    </>
  );
}
